export default (value: string | null) => {
  // Hyphens and apostrophes (straight and curly) appear in real names,
  // e.g. Smith-Jones and O'Brien
  const nameRegex = new RegExp(/^[A-Za-z\s'’-]*$/)

  const matchRegexExactly = (string: string, regex: RegExp) => {
    const match = regex.exec(string)
    return match && string === match[0]
  }

  if (value && !matchRegexExactly(value, nameRegex)) {
    return "Name can only include letters, spaces, hyphens and apostrophes"
  }

  return true
}
